import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { Plus, Search, ChevronRight } from 'lucide-react';

const API = 'https://crm.ashbournesystems.ca/api';

const inputStyle = {
  width: '100%', padding: '0.75rem', background: '#0e0804',
  border: '1px solid #2a1a0e', color: '#F5ECD7', fontSize: '0.85rem',
  outline: 'none', boxSizing: 'border-box', marginBottom: '1rem'
};

const labelStyle = {
  display: 'block', fontSize: '0.65rem', color: '#8a6840',
  letterSpacing: '0.12em', marginBottom: '6px'
};

export default function Clients({ token }) {
  const [clients, setClients] = useState([]);
  const [search, setSearch] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ name: '', business_name: '', email: '', phone: '', city: '', source: '', notes: '' });
  const navigate = useNavigate();
  const headers = { Authorization: `Bearer ${token}` };

  const load = () => axios.get(`${API}/clients`, { headers }).then(r => setClients(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/clients`, form, { headers });
      toast.success('Client added');
      setShowForm(false);
      setForm({ name: '', business_name: '', email: '', phone: '', city: '', source: '', notes: '' });
      load();
    } catch (err) {
      toast.error(err.response?.data?.error || 'Error adding client');
    }
  };

  const filtered = clients.filter(c =>
    c.name?.toLowerCase().includes(search.toLowerCase()) ||
    c.business_name?.toLowerCase().includes(search.toLowerCase()) ||
    c.email?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
        <div>
          <h1 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#F5ECD7', marginBottom: '4px' }}>Clients</h1>
          <p style={{ color: '#8a6840', fontSize: '0.85rem' }}>{clients.length} total clients</p>
        </div>
        <button onClick={() => setShowForm(!showForm)} style={{
          display: 'flex', alignItems: 'center', gap: '0.5rem',
          background: '#B85A22', border: 'none', color: '#F5ECD7',
          padding: '0.75rem 1.25rem', cursor: 'pointer', fontSize: '0.82rem', fontWeight: 'bold'
        }}>
          <Plus size={16} /> Add Client
        </button>
      </div>

      {showForm && (
        <div style={{ background: '#1a0f08', border: '1px solid #2a1a0e', borderTop: '3px solid #B85A22', padding: '1.5rem', marginBottom: '2rem' }}>
          <h3 style={{ color: '#F5ECD7', marginBottom: '1.5rem', fontSize: '1rem' }}>New Client</h3>
          <form onSubmit={handleSubmit}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
              <div><label style={labelStyle}>FULL NAME *</label><input style={inputStyle} value={form.name} onChange={e => setForm({...form, name: e.target.value})} required /></div>
              <div><label style={labelStyle}>BUSINESS NAME</label><input style={inputStyle} value={form.business_name} onChange={e => setForm({...form, business_name: e.target.value})} /></div>
              <div><label style={labelStyle}>EMAIL *</label><input style={inputStyle} type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} required /></div>
              <div><label style={labelStyle}>PHONE</label><input style={inputStyle} value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} /></div>
              <div><label style={labelStyle}>CITY</label><input style={inputStyle} value={form.city} onChange={e => setForm({...form, city: e.target.value})} /></div>
              <div><label style={labelStyle}>HOW DID THEY FIND YOU</label><input style={inputStyle} value={form.source} onChange={e => setForm({...form, source: e.target.value})} /></div>
            </div>
            <div><label style={labelStyle}>NOTES</label><textarea style={{...inputStyle, height: '80px', resize: 'vertical'}} value={form.notes} onChange={e => setForm({...form, notes: e.target.value})} /></div>
            <div style={{ display: 'flex', gap: '1rem' }}>
              <button type="submit" style={{ background: '#B85A22', border: 'none', color: '#F5ECD7', padding: '0.75rem 1.5rem', cursor: 'pointer', fontWeight: 'bold' }}>Save Client</button>
              <button type="button" onClick={() => setShowForm(false)} style={{ background: 'transparent', border: '1px solid #2a1a0e', color: '#8a6840', padding: '0.75rem 1.5rem', cursor: 'pointer' }}>Cancel</button>
            </div>
          </form>
        </div>
      )}

      <div style={{ position: 'relative', marginBottom: '1.5rem' }}>
        <Search size={16} color="#8a6840" style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)' }} />
        <input
          placeholder="Search clients..."
          value={search} onChange={e => setSearch(e.target.value)}
          style={{ ...inputStyle, paddingLeft: '2.5rem', marginBottom: 0 }}
        />
      </div>

      <div style={{ background: '#1a0f08', border: '1px solid #2a1a0e' }}>
        {filtered.length === 0 ? (
          <div style={{ padding: '3rem', textAlign: 'center', color: '#8a6840' }}>No clients found</div>
        ) : filtered.map((c, i) => (
          <div key={c.id} onClick={() => navigate(`/clients/${c.id}`)} style={{
            padding: '1rem 1.5rem', borderBottom: i < filtered.length - 1 ? '1px solid #2a1a0e' : 'none',
            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
            cursor: 'pointer', transition: 'background 0.2s'
          }}
          onMouseEnter={e => e.currentTarget.style.background = '#221208'}
          onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
            <div>
              <div style={{ color: '#F5ECD7', fontWeight: 'bold', fontSize: '0.9rem' }}>{c.business_name || c.name}</div>
              <div style={{ color: '#8a6840', fontSize: '0.75rem' }}>{c.name} · {c.email} · {c.city}</div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
              <div style={{ textAlign: 'right' }}>
                <div style={{ fontSize: '0.72rem', color: '#B85A22' }}>{c.project_count} project{c.project_count !== 1 ? 's' : ''}</div>
                {c.active_maintenance > 0 && <div style={{ fontSize: '0.65rem', color: '#4a9a4a' }}>maintenance active</div>}
              </div>
              <ChevronRight size={16} color="#8a6840" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
